import React from 'react';

const Header = () => {
  return (
    <header id="form__header">
      <h1>Formulario</h1>
      <div className="form__intro">
        <div className="form__intro--epigrafre">
        <p>carga de productos
        </p>
 
        
        </div>
        
      </div>
    </header>
    
  );
};

export default Header;
